import { render, staticRenderFns } from "./AllMessage.vue?vue&type=template&id=f386ae6c&scoped=true&"
import script from "./AllMessage.vue?vue&type=script&lang=js&"
export * from "./AllMessage.vue?vue&type=script&lang=js&"
import style0 from "./AllMessage.vue?vue&type=style&index=0&id=f386ae6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f386ae6c",
  null
  
)

export default component.exports